query getCompanyEmailFunnelsStatistics {
  companyEmailFunnelsStatistics: getCompanyEmailFunnelsStatistics {
    sent
    uniqueOpens
    uniqueLinksClicked
  }
}
